import { lazy } from 'react';

export const LazyHelpPage = lazy(
  () =>
    import(/* webpackChunkName: "hellospa--page--help-page" */ './help-page'),
);
